interface FreeUpUsernameScope extends ng.IScope {
  adminDashboardApi: any;
  submit           : ( form : ng.IFormController ) => void;
  user             : any;
}

export function FreeUpUsernameCtrl (
  $uibModalInstance: any,
  $scope        : FreeUpUsernameScope,
  $translate    : ng.translate.ITranslateService,
  AdminDashboard: any,
  messages      : any
) {
  $scope.adminDashboardApi = new AdminDashboard();

  $scope.user = {
    username: ''
  };

  $scope.submit = function ( form : ng.IFormController ) : void {
    $scope.adminDashboardApi.renameUser($scope.user.username)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.USERNAME_FREED_UP', { username: $scope.user.username }), 'success');

      $uibModalInstance.close();
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };
};
